<template>
    <div class="modal fade " :class="{ show: abrir_modal }" :style="abrir_modal ? mostrar_modal : 'ocultarModal'">
        <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mt-0 font-16" v-text="titulo"></h5>
                    <button type="button" class="close" @click="cerrarModal" data-dismiss="modal"
                        aria-hidden="true">×</button>
                </div>
                <div class="modal-body">

                    <div class="row">

                        <div class="col-md-12 col-12 col-sm-12 col-lg-8 col-xl-8">
                            <div class="card rounded">
                                <div class="card-body">
                                    <h6 class="card-title" style=" margin-bottom: 0px !important;">Lista de clientes <b
                                            v-text="lista_clientes.length"></b></h6>

                                    <hr class="my-3"
                                        style="margin-top: 10px !important;margin-bottom: 10px !important;">

                                    <div class="row">

                                        <div class="col-md-6 col-sm-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label for="estado">Referencia</label>
                                                <select class="custom-select"
                                                    @change="listar(1, filtros.registros_mostrar, 2)"
                                                    v-model="filtros.referencia">
                                                    <option value="0">-----</option>
                                                    <option v-for="(item, index) in lista_referencias" :key="index"
                                                        :value="item.id" v-text="item.nombre"></option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label for="estado">R. Mostrar</label>
                                                <input @change="listar(1, filtros.registros_mostrar, 2)"
                                                    v-model="filtros.registros_mostrar" type="number"
                                                    class="form-control form-control-sm">
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label for="estado">Seleccionar todos</label>
                                                <div class="btn-group" role="group" aria-label="Basic example">
                                                    <button type="button" @click="checkTodo()"
                                                        class="btn btn-primary"><i class="fas fa-check"></i></button>
                                                    <button type="button" @click="noCheck()" class="btn btn-danger"><i
                                                            class="fas fa-ban"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <input @input="buscarNombre()" v-model="filtros.nombre" type="text"
                                        class="form-control form-control-sm" placeholder="Nombre del cliente">

                                    <hr class="my-3"
                                        style="margin-top: 10px !important;margin-bottom: 10px !important;">

                                    <div class="d-flex justify-content-between mb-2 pb-2"
                                        v-for="(item, index) in lista_clientes" :key="index">
                                        <div class="d-flex align-items-center">
                                            <img class="chat-img" src="img/noimageuser.png" alt="">
                                            <div class="ml-3">
                                                <h6 class="mb-0 font-15" v-text="item.fullname"></h6>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="checkbox checkbox-primary d-inline">
                                                <input type="checkbox" :id="item.id" :value="item.id"
                                                    v-model="lista_seleccionada">
                                                <label :for="item.id" class="cr"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="my-3"
                                        style="margin-top: 10px !important;margin-bottom: 10px !important;">

                                    <nav>
                                        <ul
                                            class="pagination singel-page flex-wrap justify-content-center align-items-center">
                                            <li class="page-item" v-if="pagination.current_page > 1">
                                                <a class="page-link"
                                                    @click.prevent="cambiarPagina(pagination.current_page - 1)"
                                                    href="#"><i class="ti-angle-left"></i></a>
                                            </li>
                                            <li class="page-item" v-for="page in pagesNumber" :key="page"
                                                :class="[page == isActived ? 'active' : '']">
                                                <a class="page-link" href="#" @click.prevent="cambiarPagina(page)"
                                                    v-text="page"></a>
                                            </li>
                                            <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                                <a class="page-link" href="#"
                                                    @click.prevent="cambiarPagina(pagination.current_page + 1)"><i
                                                        class="ti-angle-right"></i></a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>

                        </div>

                        <div class="col-md-12 col-12 col-sm-12 col-lg-4 col-xl-4">
                            <div class="card rounded">
                                <div class="card-body">
                                    <h6 class="card-title" style=" margin-bottom: 0px !important;">Lista de usuarios
                                    </h6>
                                    <hr class="my-3"
                                        style="margin-top: 10px !important;margin-bottom: 10px !important;">
                                    <input v-model="usuario_buscar" type="text" class="form-control form-control-sm"
                                        placeholder="Nombre del usuario">
                                    <hr class="my-3"
                                        style="margin-top: 10px !important;margin-bottom: 10px !important;">

                                    <div class="d-flex justify-content-between mb-2 pb-2"
                                        v-for="(item, index) in lista_usuarios_temp" :key="index">
                                        <div class="d-flex align-items-center">
                                            <img class="chat-img" :src="item.file"
                                                onerror="this.onerror=null; this.src='img/noimageuser.png'">
                                            <div class="ml-3">
                                                <h6 class="mb-0 font-15" v-text="item.fullname"></h6>
                                            </div>
                                        </div>
                                        <div class="custom-control custom-radio">
                                            <input type="radio" :value="item.id" v-model="usuario_id" :id="item.id"
                                                @click="check(item.id)" name="customRadio2"
                                                class="custom-control-input">
                                            <label class="custom-control-label" :for="item.id"></label>
                                        </div>
                                    </div>
                                    <hr class="my-3"
                                        style="margin-top: 10px !important;margin-bottom: 10px !important;">

                                    <pagination-simple :dataItems="usuariosData" :pageSize="10" :maxPages="10"
                                        @changePage="usuariosOnChangePage"
                                        :paginateClass="'pagination singel-page flex-wrap justify-content-center align-items-center'"></pagination-simple>
                                </div>
                            </div>

                        </div>

                    </div>




                </div>

                <div class="modal-footer">
                    <button type="button" @click="tranferir()" class="btn btn-sm btn-primary">Guardar</button>
                    <button type="button" @click="cerrarModal" class="btn btn-sm btn-secondary">Cerrar</button>
                </div>

            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div>
</template>

<script>
import { alertasM } from '../../../../util.js';
import Pagination from '../componentes/paginate.vue';
export default {
    components: {
        'pagination-simple': Pagination,
    },
    mixins: [alertasM],
    data() {
        return {
            //Modal
            abrir_modal: false,
            mostrar_modal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultar_modal: {
                display: 'none'
            },
            lista_usuarios: [],
            lista_usuarios_temp: [],
            lista_clientes: [],
            lista_seleccionada: [],
            lista_referencias: [],
            usuario_id: '',
            tipo: '',
            titulo: '',
            cliente_buscar: '',
            usuario_buscar: '',
            pagination: {
                'total': 0,
                'current_page': 0,
                'per_page': 0,
                'last_page': 0,
                'from': 0,
                'to': 0,
            },
            offset: 3,
            filtros: {
                tipo: 0,
                referencia: 0,
                registros_mostrar: 6,
                nombre: ''
            },
        }
    },
    computed: {
        usuariosData() {
            return this.lista_usuarios.filter(cli => {
                return cli.fullname.toLowerCase().includes(this.usuario_buscar.toLowerCase())
            });
        },

        isActived: function () {
            return this.pagination.current_page;
        },
        //Calcula los elementos de la paginación
        pagesNumber: function () {
            if (!this.pagination.to) {
                //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                return []; //Array vacio
            }

            var from = this.pagination.current_page - this.offset;
            // console.log("bengy: ", from);
            if (from < 1) {
                //si la pagina actual es 0 entonces la igualamos  a uno
                from = 1;
            }
            //la suma de la variable rom + el doble de la varialbe offset
            var to = from + this.offset * 2;
            // console.log("bengy2: ", from);
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }

            var pagesArray = [];
            while (from <= to) {
                /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                            from++; */
                //Solucion
                if (
                    (from >= this.pagination.current_page - 1) &
                    (from <= this.pagination.current_page + 3)
                )
                    pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },

    },
    methods: {

        abrirModal() {
            this.abrir_modal = true
        },

        cerrarModal() {
            this.$emit("onClose", '');
            this.abrir_modal = false
            this.lista_usuarios = []
            this.lista_usuarios_temp = []
            this.lista_clientes = []
            this.lista_seleccionada = []
            this.lista_referencias = []
            this.usuario_id = ''
            this.tipo = ''
            this.titulo = ''
            this.cliente_buscar = ''
            this.usuario_buscar = ''
            this.pagination = {
                'total': 0,
                'current_page': 0,
                'per_page': 0,
                'last_page': 0,
                'from': 0,
                'to': 0,
            }
            this.offset = 3,
                this.filtros = {
                    tipo: 0,
                    referencia: 0,
                    registros_mostrar: 6,
                    nombre: ''
                }
        },

        cambiarPagina(page) {
            let me = this;
            //Actualiza la página actual
            me.pagination.current_page = page;
            //Envia la petición para visualizar la data de esa página
            //2 = Peticion realizada despues de haber pasado la de inicio
            me.listar(page, me.filtros.registros_mostrar, 2);
        },

        async listar(page, pag_mostrar, tipo) {
            let me = this;
            try {
                var url = 'tratar-data-cliente/listar-clientes-usuarios';

                let get = {
                    'page': page,
                    'pag_mostrar': pag_mostrar,
                    'filtro': JSON.stringify(me.filtros),
                    'tipo': tipo
                };

                this.openCargando()
                let response = await axios.get(url, { params: get });
                var respuesta = response.data;

                // 1 = peticion de inicio
                if (tipo == 1) {
                    me.lista_usuarios = respuesta.usuarios
                    me.lista_referencias = respuesta.referencias
                }

                me.lista_clientes = respuesta.clientes
                me.pagination = respuesta.pagination;
                me.abrirModal()

                this.openCargando(true);
            } catch (error) {
                this.openCargando(true);
                console.error(error);
                if (error.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                }
            }
        },

        usuariosOnChangePage(pageOfItems) {
            this.lista_usuarios_temp = pageOfItems;
        },

        checkTodo() {
            this.lista_seleccionada = this.lista_clientes.map(function (i) {
                return i.id
            });
        },

        noCheck() {
            this.lista_seleccionada = []
        },

        buscarNombre: _.debounce(function (e) {
            this.listar(1, this.filtros.registros_mostrar, 2)
        }, 500),

        async tranferir() {
            let me = this;

            if (me.usuario_id == null && me.lista_seleccionada.length == 0) {
                me.notify(" Seleccione un usuario y las cotizaciones a transferir", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                return;
            }
            var url = '/tratar-data-cliente/tranferir-cotizaciones';

            let post = {
                'lista': me.lista_seleccionada,
                'user_id': me.usuario_id,
            };

            try {
                me.openCargando();
                let response = await axios.post(url, post);
                var respuesta = response.data;
                me.openCargando(true);
                if (respuesta.status) {
                    me.notify(" Trasferencia realizada con exito", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
                    me.cerrarModal();
                } else {
                    me.notify(" Ha ocurrido un error al realizar la tranferencia", "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')
                    console.error(respuesta.data.mensaje);
                }

            } catch (error) {
                this.openCargando(true);
                console.error(error);
                if (error.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                }
            }
        },

        check(id) {
            this.usuario_id = id;
        }
    },
    mounted() {

        var actual = this;

        EventBus.$on('tranferencia-modal', function Escucha(value) {
            if (value == 1) {
                actual.tipo = 1 //'cotizacion'
                actual.titulo = 'Transferencia masiva de tratado de datos.'
            } else {
                actual.tipo = 2 //'renovacion'
                actual.titulo = 'Transferencia masiva de renovaciones.'

            }
            //actual.titulo = value
            // 1 = peticion de inicio
            actual.listar(1, actual.filtros.registros_mostrar, 1)
        });
    }
}
</script>

<style></style>
